var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonKinesisVideoStreams32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Kinesis-Video-Streams_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Kinesis-Video-Streams_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Kinesis-Video-Streams",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.888,15.913 C7.234,15.913 4,19.801 4,22.119 L3,22.119 C3,18.587 7.767,16.346 17.172,15.413 C7.767,14.48 3,12.238 3,8.706 L4,8.706 C4,11.024 7.234,14.913 28.888,14.913 L28.888,15.913 Z M11.908,18.792 L11.908,19.854 C7.51,21.491 6.874,23.836 6.874,25.952 L5.874,25.952 C5.874,23.575 6.592,20.653 11.908,18.792 L11.908,18.792 Z M11.908,21.838 L11.908,23.078 C9.754,24.82 9.748,26.931 9.748,28.826 L8.748,28.826 C8.748,26.746 8.752,23.951 11.908,21.838 L11.908,21.838 Z M27.931,26.775 C27.931,27.379 27.44,27.871 26.835,27.871 L16.028,27.871 C15.423,27.871 14.931,27.379 14.931,26.775 L14.931,19.967 C14.931,19.363 15.423,18.871 16.028,18.871 L26.835,18.871 C27.44,18.871 27.931,19.363 27.931,19.967 L27.931,26.775 Z M26.835,17.871 L16.028,17.871 C14.871,17.871 13.931,18.811 13.931,19.967 L13.931,26.775 C13.931,27.931 14.871,28.871 16.028,28.871 L26.835,28.871 C27.991,28.871 28.931,27.931 28.931,26.775 L28.931,19.967 C28.931,18.811 27.991,17.871 26.835,17.871 L26.835,17.871 Z M5.874,4.874 L6.874,4.874 C6.874,8.891 9.49,12.997 28.888,12.997 L28.888,13.997 C8.609,13.997 5.874,9.386 5.874,4.874 L5.874,4.874 Z M8.748,2 L9.748,2 C9.748,5.617 9.748,11.081 28.888,11.081 L28.888,12.081 C10.303,12.081 8.748,7.101 8.748,2 L8.748,2 Z M20.405,24.588 L20.405,22.177 L22.797,23.382 L20.405,24.588 Z M24.133,22.935 L20.129,20.918 C19.976,20.84 19.791,20.848 19.642,20.939 C19.494,21.031 19.405,21.192 19.405,21.365 L19.405,25.4 C19.405,25.574 19.494,25.735 19.643,25.826 C19.723,25.875 19.814,25.9 19.905,25.9 C19.982,25.9 20.059,25.883 20.129,25.847 L24.133,23.828 C24.302,23.743 24.409,23.571 24.409,23.382 C24.409,23.193 24.302,23.02 24.133,22.935 L24.133,22.935 Z",
    id: "Amazon-Kinesis-Video-Streams_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonKinesisVideoStreams32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Kinesis-Video-Streams_32.26b0c07a449fcceae8d7fa4eeb711e50.svg";
export { ForwardRef as ReactComponent };